import React, { Component } from 'react';
import {
    Grid,
    Row,
    Col,
    Tabs,
    Tab,
    Table,
    OverlayTrigger,
    Tooltip,
} from 'react-bootstrap';
import { getTable } from '../../views/Components/JQueryTable/JQueryTableLogic.jsx';
import Card from '../../components/Card/Card.jsx';
import SweetAlert from "react-bootstrap-sweetalert";
import Button from '../../elements/CustomButton/CustomButton.jsx';
import SolicitudTab from './SolicitudTab.jsx';
import RendicionFondosTab from './RendicionFondosTab.jsx';
import IncubationService from "../../services/IncubationService";
import AdministrationService from "../../services/AdministrationService";
import ModalAlta from './ModalAlta.jsx';

class Main extends Component{
  constructor(props){
    super(props);
    this.state = {
        alert: null,
        key: 1,
        currentEquipo: null,
        tiposComprobantes: null,
    };
    this.incubationService = new IncubationService();
    this.administrationService = new AdministrationService();
    this.handleSelect = this.handleSelect.bind(this);
    this.errorAlert = this.errorAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.updateDevuelto = this.updateDevuelto.bind(this);
    this.saveSolicitud = this.saveSolicitud.bind(this);
    this.generateEquipoTable = this.generateEquipoTable.bind(this);
    this.saveEquipo = this.saveEquipo.bind(this);
    this.getEquipmentList = this.getEquipmentList.bind(this);
    this.deleteEquipo = this.deleteEquipo.bind(this);
    this.confirmDeleteEquipment = this.confirmDeleteEquipment.bind(this);
    this.confirmUpdate = this.confirmUpdate.bind(this);
    this.getTiposComprobantes = this.getTiposComprobantes.bind(this);
  }

  componentWillMount() {
    this.getEquipmentList(null);
    this.getTiposComprobantes();
  }

  getEquipmentList(disponibles) {
    this.administrationService.getEquipmentList(disponibles)
      .then(res => {
        this.setState({equipmentList: res});
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ocurrio un error mientras se cargaban los datos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
  }

  getTiposComprobantes() {
    this.administrationService.getTiposComprobantes()
    .then(res => {
      const tiposComprobantes = res.comprobantes.map((item) => {
        return {value: item.codigo, label: item.descripcion};
      });
      this.setState({tiposComprobantes});
    })
    .catch(err => {
      this.errorAlert(
        <div>
          Ocurrio un error mientras se cargaban los datos, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>);
    });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }
  showAlert(message) {
    this.setState({
      alert: message
    });
  }
  handleSelect(key){
    this.setState({key});
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block", marginTop: "-100px" }}
          title="Error"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }

  confirmUpdate(idsolicitud, idequipo, devueltoEquipo) {
    this.setState({
      alert: (
        <SweetAlert
          info
          style={{ display: "block", marginTop: "-100px" }}
          title="Estado de devolución"
          onConfirm={() => this.updateDevuelto(idsolicitud, idequipo, devueltoEquipo)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="warning"
          confirmBtnText="Si, cambiar!"
          cancelBtnText="Cancelar"
          showCancel
        >
          {`Cambiar el estado de devolución de un equipo?`}
        </SweetAlert>
      )
    });
  }

  updateDevuelto(idsolicitud, idequipo, devueltoEquipo) {
    this.hideAlert();
    const table = getTable('solicitudTab');
    this.administrationService
      .updateDevuelto(idsolicitud, idequipo, devueltoEquipo)
      .then(res => {
        this.setState({currentEquipo: null, equipmentList: null})
        this.getEquipmentList(null);
        table.clear();
        table.ajax.reload();
        table.draw();
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Solicitud Actualizada!</div>), 10);
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ocurrio un error al actualizar la solicitud, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
  }

  saveSolicitud(solicitud, callback) {
    const table = getTable('solicitudTab');
    this.administrationService
      .postSolicitud(solicitud)
      .then(res => {
        this.setState({currentEquipo: null, equipmentList: null}, this.getEquipmentList(null));
        table.clear();
        table.ajax.reload();
        table.draw();
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Solicitud Guardada!</div>), 10);
        callback();
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ocurrio un error mientras se guardaba la solicitud, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
  }

  confirmDeleteEquipment(nombre, id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Dar de baja?"
          onConfirm={() => this.deleteEquipo(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Dar de baja"
          cancelBtnText="Cancelar"
          showCancel
        >
          {`Está seguro de dar de baja el equipo ${nombre}?`}
        </SweetAlert>
      )
    });
  }

  deleteEquipo(id) {
    this.hideAlert();
    this.administrationService
      .deleteEquipment(id)
      .then(res => {
        this.setState({equipmentList: null})
        this.getEquipmentList(null);
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Equipo dado de baja!</div>), 10);
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ocurrio un error mientras se guardaba el equipo, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
  }

  saveEquipo(equipo, callback) {
    this.administrationService
      .postEquipment(equipo)
      .then(res => {
        this.setState({currentEquipo: null, equipmentList: null})
        this.getEquipmentList(null);
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Equipo Guardado!</div>), 10);
        callback();
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ocurrio un error mientras se guardaba el equipo, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>);
      });
  }

  generateEquipoTable() {
    let tooltipBaja = <Tooltip id="tooltip">Dar de baja</Tooltip>;
    let tooltipRename = <Tooltip id="tooltip">Renombrar</Tooltip>;
    const html = this.state.equipmentList.map((item, index) => {
      return (
        <tr key={index}>
          <td style={{textAlign: 'left'}}>{item.nombre}</td>
          <td style={{textAlign: 'center'}}>
            {parseInt(item.disponible, 10) ?
              <i style={{color: '#2ee41f'}} className="fa fa-check"></i> :
              <i style={{color: '#e40040'}} className="fa fa-times"></i>
            }
          </td>
          <td className="text-right" style={{width: 0}}>
            <OverlayTrigger placement="top" trigger={['hover', 'focus']} overlay={tooltipRename}>
              <Button
                simple bsStyle="warning" bsSize="xs"
                onClick={() => this.setState({altaModal: true, currentEquipo: {nombre: item.nombre, descripcion: item.descripcion, id: item.id, disponible: parseInt(item.disponible, 10) ? true : false}})}
              >
                  <i className="fa fa-edit"></i>
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" trigger={['hover', 'focus']} overlay={tooltipBaja}>
              <Button simple bsStyle="danger" bsSize="xs" onClick={() => this.confirmDeleteEquipment(item.nombre, item.id)} >
                  <i className="fa fa-ban"></i>
              </Button>
            </OverlayTrigger>

          </td>
        </tr>
      );
    });
    return html;
  }

  render(){
    if (!this.state.equipmentList || !this.state.tiposComprobantes) {
      return (<div className="main-content"></div>);
    }
    return (
      <div className="main-content">
        {this.state.alert}
        <Grid fluid={true}>
          <Row>
            <Col md={12}>
              <Card
                content={
                  <div>
                    <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="administration-tabs">
                      <Tab eventKey={1} title="Solicitud de Equipamiento">
                        {this.state.key === 1 &&
                          <SolicitudTab
                            confirmUpdate={this.confirmUpdate} saveSolicitud={this.saveSolicitud}
                            administrationService={this.administrationService} errorAlert={this.errorAlert}
                            currentRole={this.props.currentUser.roles[0]}
                          />
                        }
                      </Tab>
                      {this.props.currentUser.roles[0] !== 'Asistente Técnico de Gestión' &&
                        <Tab eventKey={2} title={<span><i className="fa fa-cogs"></i></span>}>
                          <div style={{textAlign:'right', paddingBottom:'5px'}} className="visible-xs-block">
                            <Button bsStyle="primary" bsSize="sm" fill block wd onClick={() => this.setState({altaModal: true})}>
                              Alta de equipo
                            </Button>
                          </div>
                          <div style={{textAlign:'right', paddingBottom:'5px'}} className="hidden-xs">
                            <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({altaModal: true})}>
                              Alta de equipo
                            </Button>
                          </div>
                          <h6>Equipos</h6><br/>
                          {this.state.equipmentList.length === 0 ?
                            <div>No hay equipos cargados!</div> :
                            <Table>
                              <thead>
                                <tr>
                                  <th style={{textAlign: 'left'}}>Equipo</th>
                                  <th style={{textAlign: 'center'}}>Disponible</th>
                                  <th style={{textAlign: 'right'}}>Acciones</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.generateEquipoTable()}
                              </tbody>
                            </Table>
                          }
                        </Tab>
                      }
                      <Tab eventKey={3} title="Rendición Fondos Generales">
                        {this.state.key === 3 &&
                          <RendicionFondosTab
                            showAlert={this.showAlert} hideAlert={this.hideAlert} errorAlert={this.errorAlert}
                            pushNotification={this.props.pushNotification}
                            administrationService={this.administrationService}
                            tiposComprobantes={this.state.tiposComprobantes}
                          />
                        }
                      </Tab>
                    </Tabs>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {this.state.altaModal &&
          <ModalAlta
            equipo={this.state.currentEquipo}
            closeModal={() => this.setState({altaModal: false, currentEquipo: null})}
            saveEquipo={this.saveEquipo}
          />
        }
      </div>
    );
  }
}
export default Main;



// WEBPACK FOOTER //
// ./src/views/Administration/Main.jsx